module.exports = __webpack_public_path__ + "img/ls3.381aa7bc.webp";